import { deleteKeysStartingWith, findValuesByKey } from "./findValuesByKey";

const isActualServiceRef = (ref: unknown): ref is string =>
  typeof ref === "string" && ref.length > 0;

export const getAdditionalServiceRefsWithoutMarketplace = (
  additionalServices: Record<string, unknown> | null | undefined
): string[] => {
  const additionalServicesCopy = JSON.parse(
    JSON.stringify(additionalServices || {})
  );

  deleteKeysStartingWith(additionalServicesCopy, "marketplace");

  return findValuesByKey(additionalServicesCopy, "ref").filter(
    isActualServiceRef
  );
};
